module.exports = __webpack_public_path__ + "static/media/restapi.ca5b9d80.png";